import OrientationOverlay from './OrientationOverlay';
export default OrientationOverlay;
